<script>
import PrefectureList from '../../../mixins/PrefectureList'
import ZipCodeSearch from "../../../components/ZipCodeSearch.vue";
import SearchZipModal from "../../components/SearchZipModal.vue";

export default {
  name: "SpotEmissionLocationDialog",
  components: {SearchZipModalButton: SearchZipModal, ZipCodeSearch},
  mixins: [PrefectureList],
  props: {
    enableDialog: {
      type: Boolean,
      required: true,
      default: false
    },
    masterEmission: {
      type: Object,
      default: () => {},
    },
    location: {
      type: Object,
      default: () => null,
    }
  },
  data() {
    return {
      objectTime: null,
      enableSearchZipModal: false,
      forms: {
        name: null,
        zip_code: null,
        address: null,
        prefecture_code: null,
        address_1: null,
        address_2: null,
        address_3: null,
        phone_number: null,
      }
    }
  },
  computed: {},
  watch: {
    /**
     * enableDialogの監視
     * 変数の初期化・設定を行う.
     * @param newVal
     */
    enableDialog: function (newVal) {
      this.objectTime = this.$dayjs().unix()
      Object.assign(this.forms, this.$options.data().forms);
      this.$nextTick(() => this.$refs.spotLocationFormValidation.reset())
      if (newVal) {
        if (this.location) {
          this.forms = this.location;
        }
      }
    }
  },
  created() {},
  methods: {
    searchZipButtonClickEvent () {
      this.enableSearchZipModal = true;
    },
    /**
     * 郵便番号検索 コールバック
     * @param content
     */
    setAddress (content) {
      this.forms.prefecture_code = `${content.pref_code}`;
      this.forms.address_1 = `${content.locality}`;
      this.forms.address_2 = `${content.street}`;
    },
    /**
     * 排出事業者をコピーボタン クリックイベント
     */
     copyFromEmissionButtonClickEvent () {
      this.forms.name = this.masterEmission.name
      this.forms.zip_code = this.masterEmission.zip_code
      this.forms.prefecture_code = this.masterEmission.prefecture_code
      this.forms.address_1 = this.masterEmission.address_1
      this.forms.address_2 = this.masterEmission.address_2
      this.forms.address_3 = this.masterEmission.address_3
      this.forms.phone_number = this.masterEmission.phone_number
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback');
    },
    /**
     * 登録ボタン クリックイベント
     */
    registerButtonClickEvent () {
      this.$refs.spotLocationFormValidation.validateWithInfo().then(({ isValid, errors }) => {
        if (isValid) {
          const prefectureName = this.prefectureNameBy(this.forms.prefecture_code);
          this.forms.address = `${prefectureName}${this.nullToBlank(this.forms.address_1)}${this.nullToBlank(this.forms.address_2)}${this.nullToBlank(this.forms.address_3)}`;
          this.$emit('registerCallback', this.forms);
        }
      })
    },

    closeModal () {
      this.enableSearchZipModal = false;
    },
    reflectFullCallback (address) {
      this.forms.zip_code = address.zip_code;
      this.forms.prefecture_code = `${address.prefecture_code}`;
      this.forms.address_1 = address.city ? address.city : '';
      this.forms.address_2 = address.town ? address.town : '';
    },
    reflectZipCallback (zipCode) {
      this.forms.zip_code = zipCode
    },

  },
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="800"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <validation-observer
      ref="spotLocationFormValidation"
    >
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>スポット排出事業者の設定</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text
          style="max-height: 60vh;overflow-y: auto"
        >
          <!-- コピーボタン -->
          <v-row>
            <v-col class="text-right">
              <v-btn
                class="primary"
                @click="copyFromEmissionButtonClickEvent"
              >
                排出事業者情報をコピー
              </v-btn>
            </v-col>
          </v-row>
          <!-- /コピーボタン -->

          <!-- 事業場名 -->
          <v-row>
            <v-col>
              <validation-provider
                v-slot="{ errors }"
                :vid="`name-${objectTime}`"
                class="requiredMark"
                name="事業場名"
                rules="required|max:60"
              >
                <v-text-field
                  v-model="forms.name"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="事業場名"
                  outlined
                  persistent-placeholder
                  placeholder="例）△△△△　株式会社"
                >
                  <template v-slot:label>
                    <span>事業場名</span>
                    <span class="ml-1">
                      ({{ forms.name?.length || 0 }} / 60)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /事業場名 -->

          <!-- 郵便番号 -->
          <v-row>
            <v-col cols="12" md="8">
              <validation-provider
                v-slot="{ errors }"
                :vid="`zip_code-${objectTime}`"
                :rules="{zip_code: true, required: true, max:8 }"
                class="requiredMark"
                name="郵便番号"
              >
                <v-text-field
                  v-model="forms.zip_code"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  hint="ハイフンを含めて入力してください"
                  label="郵便番号"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）111-1111"
                >
                  <template v-slot:label>
                    <span>郵便番号</span>
                    <span class="ml-1">
                      ({{ forms.zip_code?.length || 0 }} / 8)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                  <template v-slot:append-outer>
                    <zip-code-search
                      :zip-code="forms.zip_code"
                      @zipAddress="setAddress"
                    />
                    &nbsp;
                    <v-btn
                      outlined
                      small
                      @click="searchZipButtonClickEvent"
                    >
                      住所→郵便番号
                    </v-btn>
                  </template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /郵便番号 -->

          <!-- 都道府県／市区町村 -->
          <v-row>
            <v-col cols="12" md="3">
              <validation-provider
                v-slot="{ errors }"
                :vid="`prefecture_code-${objectTime}`"
                class="requiredMark"
                name="都道府県"
                rules="required"
              >
                <v-autocomplete
                  v-model="forms.prefecture_code"
                  :error-messages="errors"
                  :items="prefList"
                  dense
                  hide-details="auto"
                  item-text="text"
                  item-value="value"
                  label="都道府県"
                  outlined
                  persistent-placeholder
                  placeholder="例）東京都"
                />
              </validation-provider>
            </v-col>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                :vid="`address_1-${objectTime}`"
                class="requiredMark"
                name="市区町村"
                rules="required|full_width|max:20"
              >
                <v-text-field
                  v-model="forms.address_1"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="市区町村"
                  outlined
                  persistent-placeholder
                  placeholder="例）中央区"
                >
                  <template v-slot:label>
                    <span>市区町村</span>
                    <span class="ml-1">
                      ({{ forms.address_1?.length || 0 }} / 20)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /都道府県／市区町村 -->

          <!-- 町域 -->
          <v-row>
            <v-col cols="12" md="9">
              <validation-provider
                v-slot="{ errors }"
                :vid="`address_2-${objectTime}`"
                name="町域"
                rules="full_width|max:40"
              >
                <v-text-field
                  v-model="forms.address_2"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="町域"
                  outlined
                  persistent-placeholder
                  placeholder="例）日本橋兜町"
                >
                  <template v-slot:label>
                    <span>町域</span>
                    <span class="ml-1">
                      ({{ forms.address_2?.length || 0 }} / 40)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /町域 -->

          <!-- 詳細住所 -->
          <v-row>
            <v-col md="9">
              <validation-provider
                v-slot="{ errors }"
                name="詳細住所"
                rules="max:50"
              >
                <v-text-field
                  v-model="forms.address_3"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  label="詳細住所"
                  outlined
                  persistent-placeholder
                  placeholder="例）１−２−３　○○ビル○階"
                >
                  <template v-slot:label>
                    <span>詳細住所</span>
                    <span class="ml-1">
                      ({{ forms.address_3?.length || 0 }} / 50)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /詳細住所 -->

          <!-- 電話番号 -->
          <v-row>
            <v-col cols="12" md="6">
              <validation-provider
                v-slot="{ errors }"
                :rules="{ numeric_hyphen_only: true, min: 2, max: 15 }"
                name="電話番号"
              >
                <v-text-field
                  v-model="forms.phone_number"
                  :error-messages="errors"
                  dense
                  hide-details="auto"
                  hint="電話番号を「-」ハイフン「( )」込みで入力します"
                  label="電話番号"
                  outlined
                  persistent-hint
                  persistent-placeholder
                  placeholder="例）000-0000-0000"
                >
                  <template v-slot:label>
                    <span>電話番号</span>
                    <span class="ml-1">
                      ({{ forms.phone_number?.length || 0 }} / 15)
                    </span>
                  </template>
                  <template v-slot:counter></template>
                </v-text-field>
              </validation-provider>
            </v-col>
          </v-row>
          <!-- /電話番号 -->

        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent">
            閉じる
          </v-btn>
          <v-btn
            color="primary"
            @click="registerButtonClickEvent"
          >
            登録
          </v-btn>
        </v-card-actions>
      </v-card>
    </validation-observer>
    <search-zip-modal-button
      :enable="enableSearchZipModal"
      :initial-prefecture-code="forms.prefecture_code"
      :initial-city-name="forms.address_1"
      :initial-town-name="forms.address_2"
      @reflectFullCallback="reflectFullCallback"
      @reflectZipCallback="reflectZipCallback"
      @closeCallback="closeModal"
    />
  </v-dialog>
</template>

<style scoped lang="scss">

</style>
